import {
  ImageCtaCardSection,
  OralMedHeroContentSection,
  OralMedPriceOverviewSection,
  OralMedGeneralStepCard,
  OralMedFeaturedMedSection,
  OralMedWhyDefyMedSection,
  FAQSection,
} from "@/design-system/Organisms";
import { oralMedMidImageCtaCardConfig } from "@/design-system/Organisms/ImageCtaCardSection/imageCtaCard.config";
import { oralMedFeaturedMedicineConfig } from "@/design-system/Organisms/OralMedFeaturedMedSection/featuredMed.config";
import { oralMedFaqDataConfig } from "@/design-system/Organisms/FAQSection/faq.config";

export const OralMedBgSwoopTemplate = () => {
  return (
    <>
      <div className="w-full h-full overflow-hidden bg-no-repeat bg-contain bg-[url('/images/bg-swoop.svg')] bg-[position:0_-100px]">
        <OralMedHeroContentSection />
        <OralMedPriceOverviewSection />
        <OralMedGeneralStepCard />
        <OralMedFeaturedMedSection {...oralMedFeaturedMedicineConfig} />
        <ImageCtaCardSection {...oralMedMidImageCtaCardConfig} />
        <OralMedWhyDefyMedSection />
        <FAQSection {...oralMedFaqDataConfig} />
      </div>
    </>
  );
};
export default OralMedBgSwoopTemplate;
